/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ActivationCreateResponseDto,
  ActivationFinalizationRequestDto,
  ActivationProcessStatusResponseDto,
  CardSpendResponseCardResponse,
  DeactivationRequestDto,
  DeviceDto,
  DeviceUnlinkConfirmNonSSODto,
  DeviceUnlinkConfirmSSODto,
  DeviceUnlinkNonSSODto,
  DeviceUnlinkRequestCancelDto,
  EmailOtpActivationConfirmationRequestDto,
  EmailOtpActivationConfirmationResponseDto,
  ErrorDto,
  NonSsoUserActivationCreateRequestDto,
  NonSsoUserSmsResendRequestDto,
  RefreshTokenRequestDto,
  RefreshTokenResponseDto,
  SetupBiometryDto,
  SetupBiometryResultDto,
  SmsOtpActivationConfirmationRequestDto,
  SsoUserActivationCreateRequestDto,
  TitleSubtitleDto,
  UpdateCardRequest,
  VerifyBiometryDto,
  VirtualCardDetailsTokenResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class DeviceV1<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags DeviceV1
   * @name UpdateCard
   * @request PUT:/api/m/spend-request/card
   */
  updateCard = (data: UpdateCardRequest, params: RequestParams = {}) =>
    this.http.request<CardSpendResponseCardResponse, any>({
      path: `/m/spend-request/card`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCardPath = '/m/spend-request/card'
  static updateCardMethod = 'PUT'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name UnblockDeviceFromBackoffice
   * @request POST:/api/v1/users/{userId}/device/unblock
   */
  unblockDeviceFromBackoffice = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/users/${userId}/device/unblock`,
      method: 'POST',
      ...params,
    })

  static unblockDeviceFromBackofficePath = '/v1/users/${userId}/device/unblock'
  static unblockDeviceFromBackofficeMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name DeactivateDeviceFromBackoffice
   * @request POST:/api/v1/users/{userId}/device/deactivate
   */
  deactivateDeviceFromBackoffice = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/users/${userId}/device/deactivate`,
      method: 'POST',
      ...params,
    })

  static deactivateDeviceFromBackofficePath = '/v1/users/${userId}/device/deactivate'
  static deactivateDeviceFromBackofficeMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name SsoUserActivationRequest
   * @request POST:/api/v1/users/{userId}/device/activation/request/sso
   */
  ssoUserActivationRequest = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/users/${userId}/device/activation/request/sso`,
      method: 'POST',
      ...params,
    })

  static ssoUserActivationRequestPath = '/v1/users/${userId}/device/activation/request/sso'
  static ssoUserActivationRequestMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name CancelDeviceDeactivateRequestByAdmin
   * @request POST:/api/v1/device/user/{userId}/request-cancel
   */
  cancelDeviceDeactivateRequestByAdmin = (
    userId: string,
    data: DeviceUnlinkRequestCancelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/device/user/${userId}/request-cancel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static cancelDeviceDeactivateRequestByAdminPath = '/v1/device/user/${userId}/request-cancel'
  static cancelDeviceDeactivateRequestByAdminMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name UnlinkDeviceRequestNonSso
   * @request POST:/api/v1/device/unlink
   */
  unlinkDeviceRequestNonSso = (data: DeviceUnlinkNonSSODto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/device/unlink`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static unlinkDeviceRequestNonSsoPath = '/v1/device/unlink'
  static unlinkDeviceRequestNonSsoMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name UnlinkDeviceRequestConfirmSso
   * @request POST:/api/v1/device/unlink/sso/confirm
   */
  unlinkDeviceRequestConfirmSso = (data: DeviceUnlinkConfirmSSODto, params: RequestParams = {}) =>
    this.http.request<TitleSubtitleDto, any>({
      path: `/v1/device/unlink/sso/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static unlinkDeviceRequestConfirmSsoPath = '/v1/device/unlink/sso/confirm'
  static unlinkDeviceRequestConfirmSsoMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name UnlinkDeviceRequestConfirmNonSso
   * @request POST:/api/v1/device/unlink/confirm
   */
  unlinkDeviceRequestConfirmNonSso = (
    data: DeviceUnlinkConfirmNonSSODto,
    params: RequestParams = {},
  ) =>
    this.http.request<TitleSubtitleDto, any>({
      path: `/v1/device/unlink/confirm`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static unlinkDeviceRequestConfirmNonSsoPath = '/v1/device/unlink/confirm'
  static unlinkDeviceRequestConfirmNonSsoMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name GetRefreshTokenForDevice
   * @request POST:/api/v1/device/refresh-token
   */
  getRefreshTokenForDevice = (data: RefreshTokenRequestDto, params: RequestParams = {}) =>
    this.http.request<RefreshTokenResponseDto, ErrorDto>({
      path: `/v1/device/refresh-token`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getRefreshTokenForDevicePath = '/v1/device/refresh-token'
  static getRefreshTokenForDeviceMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name DeactivateDevice
   * @request POST:/api/v1/device/deactivate
   */
  deactivateDevice = (data: DeactivationRequestDto, params: RequestParams = {}) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/device/deactivate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static deactivateDevicePath = '/v1/device/deactivate'
  static deactivateDeviceMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name SetupBiometry
   * @request POST:/api/v1/device/biometry
   */
  setupBiometry = (data: SetupBiometryDto, params: RequestParams = {}) =>
    this.http.request<SetupBiometryResultDto, any>({
      path: `/v1/device/biometry`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static setupBiometryPath = '/v1/device/biometry'
  static setupBiometryMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name DeleteBiometry
   * @request DELETE:/api/v1/device/biometry
   */
  deleteBiometry = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/device/biometry`,
      method: 'DELETE',
      ...params,
    })

  static deleteBiometryPath = '/v1/device/biometry'
  static deleteBiometryMethod = 'DELETE'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name ActivateBiometry
   * @request POST:/api/v1/device/biometry/activate
   */
  activateBiometry = (data: VerifyBiometryDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/device/biometry/activate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static activateBiometryPath = '/v1/device/biometry/activate'
  static activateBiometryMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name NonSsoUserResendSms
   * @request POST:/api/v1/device/activation/resend-sms/non-sso
   */
  nonSsoUserResendSms = (data: NonSsoUserSmsResendRequestDto, params: RequestParams = {}) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/device/activation/resend-sms/non-sso`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static nonSsoUserResendSmsPath = '/v1/device/activation/resend-sms/non-sso'
  static nonSsoUserResendSmsMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name ActivationFinalization
   * @request POST:/api/v1/device/activation/finalize
   */
  activationFinalization = (data: ActivationFinalizationRequestDto, params: RequestParams = {}) =>
    this.http.request<RefreshTokenResponseDto, ErrorDto>({
      path: `/v1/device/activation/finalize`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static activationFinalizationPath = '/v1/device/activation/finalize'
  static activationFinalizationMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name SsoUserActivationCreate
   * @request POST:/api/v1/device/activation/create/sso
   */
  ssoUserActivationCreate = (data: SsoUserActivationCreateRequestDto, params: RequestParams = {}) =>
    this.http.request<ActivationCreateResponseDto, ErrorDto>({
      path: `/v1/device/activation/create/sso`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static ssoUserActivationCreatePath = '/v1/device/activation/create/sso'
  static ssoUserActivationCreateMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name NonSsoUserActivationCreate
   * @request POST:/api/v1/device/activation/create/non-sso
   */
  nonSsoUserActivationCreate = (
    data: NonSsoUserActivationCreateRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<ActivationCreateResponseDto, ErrorDto>({
      path: `/v1/device/activation/create/non-sso`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static nonSsoUserActivationCreatePath = '/v1/device/activation/create/non-sso'
  static nonSsoUserActivationCreateMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name SmsOtpActivationConfirmation
   * @request POST:/api/v1/device/activation/confirm/sms
   */
  smsOtpActivationConfirmation = (
    data: SmsOtpActivationConfirmationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorDto>({
      path: `/v1/device/activation/confirm/sms`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static smsOtpActivationConfirmationPath = '/v1/device/activation/confirm/sms'
  static smsOtpActivationConfirmationMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name EmailOtpActivationConfirmation
   * @request POST:/api/v1/device/activation/confirm/email
   */
  emailOtpActivationConfirmation = (
    data: EmailOtpActivationConfirmationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<EmailOtpActivationConfirmationResponseDto, ErrorDto>({
      path: `/v1/device/activation/confirm/email`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static emailOtpActivationConfirmationPath = '/v1/device/activation/confirm/email'
  static emailOtpActivationConfirmationMethod = 'POST'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name GetDeviceStatus
   * @request GET:/api/v1/users/{userId}/device
   */
  getDeviceStatus = (userId: string, params: RequestParams = {}) =>
    this.http.request<DeviceDto, ErrorDto>({
      path: `/v1/users/${userId}/device`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDeviceStatusPath = '/v1/users/${userId}/device'
  static getDeviceStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags DeviceV1, deviceV1
   * @name ActivationProcessStatus
   * @request GET:/api/v1/users/{userId}/device/activation-process-status
   */
  activationProcessStatus = (userId: string, params: RequestParams = {}) =>
    this.http.request<ActivationProcessStatusResponseDto, ErrorDto>({
      path: `/v1/users/${userId}/device/activation-process-status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static activationProcessStatusPath = '/v1/users/${userId}/device/activation-process-status'
  static activationProcessStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name GetVirtualPanPreviewToken1
   * @request GET:/api/m/card/virtual/{cardId}/details-token
   */
  getVirtualPanPreviewToken = (cardId: string, params: RequestParams = {}) =>
    this.http.request<VirtualCardDetailsTokenResponse, any>({
      path: `/m/card/virtual/${cardId}/details-token`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getVirtualPanPreviewTokenPath = '/m/card/virtual/${cardId}/details-token'
  static getVirtualPanPreviewTokenMethod = 'GET'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name DeactivateDeviceByAdmin
   * @request DELETE:/api/v1/device/user/{userId}
   */
  deactivateDeviceByAdmin = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/device/user/${userId}`,
      method: 'DELETE',
      ...params,
    })

  static deactivateDeviceByAdminPath = '/v1/device/user/${userId}'
  static deactivateDeviceByAdminMethod = 'DELETE'
  /**
   * No description
   *
   * @tags DeviceV1
   * @name UnlinkDeviceRequestSso
   * @request DELETE:/api/v1/device/unlink/sso
   */
  unlinkDeviceRequestSso = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/device/unlink/sso`,
      method: 'DELETE',
      ...params,
    })

  static unlinkDeviceRequestSsoPath = '/v1/device/unlink/sso'
  static unlinkDeviceRequestSsoMethod = 'DELETE'
}
